import { render, staticRenderFns } from "./MessageSms.vue?vue&type=template&id=00f1fb98&"
import script from "./MessageSms.js?vue&type=script&lang=js&"
export * from "./MessageSms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports